/* screenmoove-global.js , centralised JS for Product page banner, Product grid badges, Popups */
(function () {
  "use strict";

  var UK_TZ = "Europe/London";
  var DEFAULT_CUTOFF_HOUR = 15;

  /* Festive override window, UK time */
  /* 2026, 2027 festive rules, orders from 25 Dec 2026 to 03 Jan 2027 deliver Monday 05 Jan 2027 */
  var HOLIDAY_START = new Date(2026, 11, 25, 0, 0, 0);  // 25 Dec 2026
  var HOLIDAY_END   = new Date(2027, 0, 3, 23, 59, 59); // 03 Jan 2027
  var HOLIDAY_FORCED_ETA = new Date(2027, 0, 5, 0, 0, 0); // 05 Jan 2027

  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ========= UK time helpers ========= */
  function getUKNowParts() {
    var parts = new Intl.DateTimeFormat("en-GB", {
      timeZone: UK_TZ,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false
    }).formatToParts(new Date());

    var m = {};
    for (var i = 0; i < parts.length; i++) {
      if (parts[i].type !== "literal") m[parts[i].type] = parts[i].value;
    }
    return m;
  }

  function getUKNow() {
    var m = getUKNowParts();
    return new Date(+m.year, (+m.month) - 1, +m.day, +m.hour, +m.minute, +m.second);
  }

  function getUKCutoffToday(cutoffHour) {
    var m = getUKNowParts();
    return new Date(+m.year, (+m.month) - 1, +m.day, cutoffHour, 0, 0);
  }

  function inHolidayWindow(ukNow) {
    return ukNow >= HOLIDAY_START && ukNow <= HOLIDAY_END;
  }

  function formatWeekday(d) {
    return d.toLocaleDateString("en-GB", { weekday: "long" });
  }

  function formatDateShort(d) {
    return d.toLocaleDateString("en-GB", { day: "numeric", month: "long" });
  }

  function formatDayDate(d) {
    return d.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
  }

  function isWeekend(d) {
    var day = d.getDay();
    return day === 0 || day === 6;
  }

  function nextWorkingDay(d) {
    var x = new Date(d);
    x.setDate(x.getDate() + 1);
    while (isWeekend(x)) x.setDate(x.getDate() + 1);
    return x;
  }

  function isAfterCutoff(ukNow, cutoffHour) {
    return ukNow.getHours() > cutoffHour || (ukNow.getHours() === cutoffHour && ukNow.getMinutes() > 0);
  }

  function isMonToThuBeforeCutoff(ukNow, cutoffHour) {
    var day = ukNow.getDay(); // 0 Sun, 6 Sat
    return day >= 1 && day <= 4 && !isAfterCutoff(ukNow, cutoffHour);
  }

  /* ========= Popups (centralised) ========= */
  function openPopupById(id) {
    var el = document.getElementById(id);
    if (el) {
      el.style.display = "flex";
      el.setAttribute("aria-hidden", "false");
    }
  }

  function closePopupById(id) {
    var el = document.getElementById(id);
    if (el) {
      el.style.display = "none";
      el.setAttribute("aria-hidden", "true");
    }
  }

  window.openPopup = window.openPopup || openPopupById;
  window.closePopup = window.closePopup || closePopupById;

  document.addEventListener("click", function (e) {
    var openBtn = e.target.closest("[data-sm-popup-open]");
    if (openBtn) {
      e.preventDefault();
      openPopupById(openBtn.getAttribute("data-sm-popup-open"));
      return;
    }

    var closeBtn = e.target.closest("[data-sm-popup-close]");
    if (closeBtn) {
      e.preventDefault();
      closePopupById(closeBtn.getAttribute("data-sm-popup-close"));
      return;
    }

    var overlay = e.target.classList && e.target.classList.contains("popup-overlay") ? e.target : null;
    if (overlay) {
      overlay.style.display = "none";
      overlay.setAttribute("aria-hidden", "true");
    }
  });

  /* ========= Shared delivery logic ========= */
  /*
    Rules, UK time, cutoff 3pm
    Monday to Thursday before 3pm, next working day delivery
    Friday before 3pm, deliver Monday
    Friday after 3pm until Sunday 23:59, deliver Tuesday
  */
  function computeDispatchAndETA(ukNow, cutoffHour) {
    var day = ukNow.getDay(); // 0 Sun, 6 Sat
    var afterCutoff = isAfterCutoff(ukNow, cutoffHour);

    var dispatchDate;
    var eta;
    var showCountdown;

    // Saturday or Sunday, dispatch Monday, deliver Tuesday
    if (day === 6 || day === 0) {
      dispatchDate = new Date(ukNow);
      while (dispatchDate.getDay() !== 1) dispatchDate.setDate(dispatchDate.getDate() + 1); // Monday
      eta = new Date(dispatchDate);
      eta.setDate(eta.getDate() + 1); // Tuesday
      showCountdown = false;
      return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: false };
    }

    // Friday
    if (day === 5) {
      if (!afterCutoff) {
        // Dispatch Friday, deliver Monday
        dispatchDate = new Date(ukNow);
        eta = new Date(ukNow);
        while (eta.getDay() !== 1) eta.setDate(eta.getDate() + 1); // Monday
        showCountdown = true;
        return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: true };
      }

      // Friday after cutoff, dispatch Monday, deliver Tuesday
      dispatchDate = new Date(ukNow);
      while (dispatchDate.getDay() !== 1) dispatchDate.setDate(dispatchDate.getDate() + 1); // Monday
      eta = new Date(dispatchDate);
      eta.setDate(eta.getDate() + 1); // Tuesday
      showCountdown = false;
      return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: true };
    }

    // Monday to Thursday
    if (day >= 1 && day <= 4) {
      if (!afterCutoff) {
        // Dispatch today, deliver next working day
        dispatchDate = new Date(ukNow);
        eta = nextWorkingDay(dispatchDate);
        showCountdown = true;
        return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: true };
      }

      // After cutoff, dispatch next working day, deliver following working day
      dispatchDate = nextWorkingDay(ukNow);
      eta = nextWorkingDay(dispatchDate);
      showCountdown = false;
      return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: true };
    }

    // Fallback, should not hit, but keep safe
    dispatchDate = nextWorkingDay(ukNow);
    eta = nextWorkingDay(dispatchDate);
    showCountdown = false;
    return { dispatch: dispatchDate, eta: eta, countdown: showCountdown, afterCutoff: afterCutoff, isWorkingDay: false };
  }

  function formatOrderNowGetIt(eta) {
    // Required format, Order now, get it Monday 5 January.
    return "Order now, get it " + formatWeekday(eta) + " " + formatDateShort(eta) + ".";
  }

  /* ========= Product page banners (supports multiple, no IDs) ========= */
  function renderExpressBanner(bannerEl, ukNow) {
    var cutoffHour = parseInt(bannerEl.getAttribute("data-cutoff-hour"), 10);
    if (isNaN(cutoffHour)) cutoffHour = DEFAULT_CUTOFF_HOUR;

    var titleEl = qs("[data-sm-express-title]", bannerEl);
    var messageEl = qs("[data-sm-express-message]", bannerEl);
    var timerEl = qs("[data-sm-express-timer]", bannerEl);

    if (!messageEl) return;

    if (inHolidayWindow(ukNow)) {
      if (titleEl) titleEl.textContent = "This item is eligible for free express shipping";
      messageEl.textContent = formatOrderNowGetIt(HOLIDAY_FORCED_ETA);
      return;
    }

    var result = computeDispatchAndETA(ukNow, cutoffHour);

    if (titleEl) {
      titleEl.textContent = "This item is eligible for express delivery";
    }

    if (result.countdown) {
      var monThuTomorrowCopy = isMonToThuBeforeCutoff(ukNow, cutoffHour);

      messageEl.innerHTML =
        "<span>Order before </span>" +
        "<span class='sm-express-timer' data-sm-express-timer>--h --m --s</span>" +
        "<span>, get it " +
          (monThuTomorrowCopy ? "by <b>tomorrow.</b>" : (formatWeekday(result.eta) + " " + formatDateShort(result.eta) + ".")) +
        "</span>" +
        "<button type='button' class='sm-express-info' aria-label='Delivery information' data-sm-popup-open='popupDelivery'>i</button>";

      timerEl = qs("[data-sm-express-timer]", bannerEl);
    } else {
      // After cutoff, and all other non-countdown scenarios stay as-is (uses exact date from system logic)
      messageEl.textContent = formatOrderNowGetIt(result.eta);
    }

    if (timerEl && result.countdown) {
      var cutoff = getUKCutoffToday(cutoffHour);
      var diff = Math.max(0, Math.floor((cutoff.getTime() - ukNow.getTime()) / 1000));
      var h = String(Math.floor(diff / 3600)).padStart(2, "0");
      var m = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
      var s = String(diff % 60).padStart(2, "0");
      timerEl.textContent = h + "h " + m + "m " + s + "s";
    }
  }

  /* ========= Product grid delivery badges (multiple cards) ========= */
  function renderGridBadge(blockEl, ukNow) {
    var cutoffHour = parseInt(blockEl.getAttribute("data-cutoff-hour"), 10);
    if (isNaN(cutoffHour)) cutoffHour = DEFAULT_CUTOFF_HOUR;

    var labelEl = qs("[data-sm-bs-label]", blockEl);
    var textEl = qs("[data-sm-bs-text]", blockEl);
    if (!labelEl || !textEl) return;

    if (inHolidayWindow(ukNow)) {
      labelEl.textContent = "Express delivery";
      textEl.textContent = "Order now, get it " + formatDayDate(HOLIDAY_FORCED_ETA) + ".";
      return;
    }

    var result = computeDispatchAndETA(ukNow, cutoffHour);
    var day = ukNow.getDay();
    var afterCutoff = isAfterCutoff(ukNow, cutoffHour);

    // Countdown only for Mon to Fri before cutoff, excluding weekend, and excluding Friday after cutoff by logic
    if (result.countdown && day >= 1 && day <= 5 && !afterCutoff) {
      labelEl.textContent = "Express delivery";

      var cutoff = getUKCutoffToday(cutoffHour);
      var diff = Math.max(0, Math.floor((cutoff.getTime() - ukNow.getTime()) / 1000));
      var h = String(Math.floor(diff / 3600)).padStart(2, "0");
      var m = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
      var s = String(diff % 60).padStart(2, "0");

      // Mon to Thu before 3pm, show "by tomorrow" (no date). Friday stays date-based.
      if (isMonToThuBeforeCutoff(ukNow, cutoffHour)) {
        textEl.textContent = "Order before " + h + "h " + m + "m " + s + "s, get it by tomorrow.";
        return;
      }

      textEl.textContent = "Order in " + h + "h " + m + "m " + s + "s, get it " + formatDayDate(result.eta) + ".";
      return;
    }

    labelEl.textContent = "Express delivery";
    textEl.textContent = "Order now, get it " + formatDayDate(result.eta) + ".";
  }

  /* ========= Education popup auto open, if you still use it ========= */
  function initEducationPopup() {
    var params = new URLSearchParams(window.location.search);
    var submitted = params.get("contact[submitted]") === "true";
    var popupHash = window.location.hash === "#popupEducation";

    if (submitted && popupHash) {
      openPopupById("popupEducation");
      var msg = document.getElementById("edu-perm-message");
      if (msg) msg.style.display = "block";
    }
  }

  /* ========= One timer to rule them all ========= */
  function tick() {
    var ukNow = getUKNow();

    // Product page express banners
    qsa("[data-sm-express-banner]").forEach(function (banner) {
      renderExpressBanner(banner, ukNow);
    });

    // Product grid delivery blocks
    qsa("[data-sm-bs-delivery]").forEach(function (block) {
      renderGridBadge(block, ukNow);
    });
  }

  function boot() {
    initEducationPopup();
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
